import ViolationsTabList from './ViolationsTabList';

export default ViolationsTabList;
